import React, { FC, useContext } from 'react'
import { ScreenContext } from 'react-components'
import { ListingSectionObject } from '../../../transports/common/listing-section-transport'
import ObjectOverviewCard from '../../common/object-overview-card'
import GridCard from '../../common/grid-card'
import { FeaturesFormatter } from '../../../models/common/features-model'
import { SuitablesModel } from '../../../models/common/suitables-model'
import { useTranslation } from '../../../hooks/locale'
import { cardEventCategories, pageTypeEventCategories } from '../../../services/analytics-service/categories'
import { BreadcrumbListTransport } from '../../../models/common/breadcrumb-model'
import { Offer } from '../../../models/common/offers-model'

interface ListingItemProps {
    listingObject: ListingSectionObject
    index: number
    requestUrl: string
    sitePathname?: string
    breadcrumbModel: BreadcrumbListTransport
    offerModel: Offer
    suitablesModel: SuitablesModel
}

const ListingItem: FC<ListingItemProps> = ({
    listingObject,
    index,
    requestUrl,
    sitePathname,
    breadcrumbModel,
    offerModel,
    suitablesModel,
}) => {
    const { isMobile } = useContext(ScreenContext)
    const { t } = useTranslation()

    const getFeaturesForListing = () => {
        const { generalEquipments, suitables, stats } = listingObject

        const suitablesMap = suitables ? suitablesModel.format(suitables) : {}

        const formatter = new FeaturesFormatter(t)

        return formatter.format(
            generalEquipments || null,
            null,
            suitablesMap,
            {},
            {},
            0,
            0,
            stats?.maxPersons || 0,
            stats?.apartmentSize || 0,
            0,
            5,
            false,
            false,
        )
    }

    const features = getFeaturesForListing()

    if (isMobile) {
        return (
            <GridCard
                key={listingObject.id}
                listingObject={listingObject}
                position={index}
                displayPrice
                displayPriceInfo
                requestUrl={requestUrl}
                sitePathname={sitePathname}
                features={features}
                showCtaButton
                isObjectOverview
                pageName={pageTypeEventCategories.OBJECT_OVERVIEW_PAGE}
                sectionName={cardEventCategories.sections.LISTINGS}
                showMaxPersonCount
                breadcrumbModel={breadcrumbModel}
                offerModel={offerModel}
                suitablesModel={suitablesModel}
            />
        )
    }

    return (
        <ObjectOverviewCard
            pageName={pageTypeEventCategories.OBJECT_OVERVIEW_PAGE}
            sectionName={cardEventCategories.sections.LISTINGS}
            showBreadcrumbsSection
            key={listingObject.id}
            listingObject={listingObject}
            features={features}
            sitePathname={sitePathname}
            showMaxPersonCount
            showRegion={false}
            breadcrumbModel={breadcrumbModel}
            offerModel={offerModel}
            suitablesModel={suitablesModel}
        />
    )
}

export default ListingItem
